<!--
 * @Author: Lemon C
 * @Date: 2024-04-28 12:09:39
 * @LastEditTime: 2026-10-12 15:18:12
-->
<template>
    <div class="sup-docs-tree">
        <div class="docs-tree-search-box">
            <div class="search-input-box">
                <el-input placeholder="搜索当前目录" prefix-icon="Search" v-model="filterText" clearable> </el-input>
            </div>
            <div class="fold-box" @click="eltree_fold_action">
                <el-tooltip effect="dark" content="折叠目录树" placement="right">
                    <img src="@/assets/imgs/general/icon_fold.png" />
                </el-tooltip>
            </div>
        </div>
        <div class="docs-tree-box">
            <el-tree
                :data="treeList"
                :props="defaultProps"
                :filter-node-method="eltree_filter_node"
                ref="ref_eltree"
                :default-expanded-keys="expandedKeys"
                :expanded-keys="eltree_unfold_node_keys"
                highlight-current
                @node-click="eltree_node_click"
                node-key="id">
                <template #default="{ node, data }">
                    <div :class="`${node.isLeaf ? 'custom-tree-node-leaf' : 'custom-tree-node-bole'}`" :scroll-node-key="data.id">
                        <span class="custom-tree-node-title-bole" v-if="!node.isLeaf" v-html="node_text_highlight(node.label, filterText)"> </span>
                        <div class="custom-tree-node-leaf-box" v-if="node.isLeaf">
                            <div class="node-leaf-content-box">
                                <div class="node-sel-content-box-text" v-html="node_text_highlight(node.label, filterText)"></div>
                            </div>
                        </div>
                    </div>
                </template>
            </el-tree>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, onBeforeUnmount, watch, getCurrentInstance, nextTick } from 'vue';
import { getCatalog } from '@/service/interface';
import { useMessageStore } from '../../stores/message';
import { useStateStore } from '@/stores/state';

const state_store = useStateStore();
const message_store = useMessageStore();

const { proxy } = getCurrentInstance();
const Level = 99;

const props = defineProps({
    share_url_data: Object, // 链接分享数据
    request_gourp: Number, // 单个请求group
    request_gourp_list: Array, // 复合请求group
    tree_node_callback: Function,
});

const ref_eltree = ref(null);
const treeList = ref([]);
const filterText = ref('');
const defaultProps = ref({
    children: 'subCatalogs',
    label: 'name',
}); //目录树别名
const expandedKeys = ref([]); //目录树默认展开id
const eltree_unfold_node_keys = ref([]); //目录树已经展开的节点id
const eltree_sel_data = ref({}); // 目录树选中节点

watch(
    () => filterText.value,
    (val) => {
        ref_eltree.value.filter(val);
    }
);

onMounted(() => {
    if (props.request_gourp_list && props.request_gourp_list.length) {
        // 复合目录树
        service_get_complex_tree();
    } else {
        service_get_tree();
    }
    message_store.addMessageHandler(message_store.M_E_TREE_AUTO_SEL, m_e_tree_auto_sel_node);
});

onBeforeUnmount(() => {
    message_store.removeMessageHandler(message_store.M_E_TREE_AUTO_SEL, m_e_tree_auto_sel_node);
});

// MARK Service 获取目录树
const service_get_tree = () => {
    proxy.$showLoading();
    getCatalog({ level: Level, group: props.request_gourp }).then((res) => {
        proxy.$hideLoading();
        if (!res.isSuccess) {
            proxy.$message.error(res.errMsg);
            return;
        }
        treeList.value = res.data;
        if (!treeList.value.length) {
            expandedKeys.value = [];
            return;
        }
        eltree_auto_loc();
    });
};

// MARK Service  获取复合目录树
const service_get_complex_tree = () => {
    let tree_list_temp = [];
    let promiseArray = [];
    props.request_gourp_list.forEach((item) => {
        let promise = getCatalog({ level: Level, group: item.group });
        promiseArray.push(promise);
        tree_list_temp.push(item);
    });
    proxy.$showLoading();
    Promise.all(promiseArray).then((response) => {
        proxy.$hideLoading();
        response.forEach((res, index) => {
            if (res.isSuccess) {
                let treeType = props.request_gourp_list[index].treeType;
                eltree_recursion_node_addType(res.data, treeType);
                tree_list_temp[index].subCatalogs = res.data;
            }
        });

        if (!tree_list_temp.length) {
            expandedKeys.value = [];
            return;
        }
        treeList.value = tree_list_temp;
        eltree_auto_loc();
    });
};

// MARK Tree  折叠目录树
const eltree_fold_action = () => {
    const treeInstance = ref_eltree.value;
    if (treeInstance) {
        let nodes = treeInstance.store._getAllNodes();
        for (let i in nodes) {
            nodes[i].expanded = false;
        }
    }
};

// MARK Tree  递归默认展开
const eltree_recursion_node = (treeList) => {
    if (treeList[0].subCatalogs && treeList[0].subCatalogs.length) {
        eltree_recursion_node(treeList[0].subCatalogs);
    } else {
        let selTreeData = treeList[0];
        expandedKeys.value.push(selTreeData.id);
        nextTick(() => {
            ref_eltree.value.setCurrentKey(selTreeData.id);
        });
        eltree_node_click(selTreeData);
    }
};

// MARK Tree  递归添加参数
const eltree_recursion_node_addType = (treeList, treeType) => {
    treeList.forEach((node) => {
        node.treeType = treeType;
        if (node.subCatalogs && node.subCatalogs.length > 0) {
            eltree_recursion_node_addType(node.subCatalogs, treeType);
        }
    });
};

// MARK el-tree  过滤节点
const eltree_filter_node = (value, data, node) => {
    if (!value) return true;
    const keyword = value.toLowerCase();
    // 展开检索到的节点及子节点
    let parentNode = node.parent;
    let labels = [data.name];
    let level = 1;
    while (level < node.level && parentNode) {
        labels = [...labels, parentNode.data.name];
        parentNode = parentNode.parent;
        level++;
    }
    // 任意节点名称包含关键词（忽略大小写）
    return labels.some((label) => {
        const txt = (label || '').toLowerCase();
        return txt.indexOf(keyword) !== -1;
    });
};

// MARK el-tree  节点文字高亮
const node_text_highlight = (text, filter) => {
    if (!filter) return text;
    const regex = new RegExp(`(${filter})`, 'gi');
    return text.replace(regex, '<span class="custom-tree-node-highlight">$1</span>');
};

// MARK el-tree 自动定位
const eltree_auto_loc = (gotoTreeId = '') => {
    let treeId = '';
    if (props.share_url_data && props.share_url_data.shareType == 1 && props.share_url_data.treeId.length) {
        treeId = props.share_url_data.treeId;
    }
    if (gotoTreeId.length) {
        treeId = gotoTreeId;
    }

    if (treeId.length) {
        let findData = find_tree_node(treeList.value, 'id', treeId);
        if (findData) {
            expandedKeys.value.push(findData.id);
            nextTick(() => {
                ref_eltree.value.setCurrentKey(findData.id);
            });
            eltree_scroll(findData);
            eltree_node_click(findData);
        } else {
            eltree_recursion_node(treeList.value);
        }
    } else {
        eltree_recursion_node(treeList.value);
    }
};

// MARK el-tree  目录树滚动
const eltree_scroll = (data) => {
    if (eltree_sel_data.value && eltree_sel_data.value.id && data.id && eltree_sel_data.value.id == data.id) {
        return; // 重复点击失效，路由切换会进行事件发送，造成重复点击，过滤掉此操作
    }
    // 延迟滚动到指定的节点, 不延时dom还没有加载无法获取
    setTimeout(() => {
        nextTick(() => {
            const node = ref_eltree.value.getNode(data.id);
            if (node) {
                const nodeEl = ref_eltree.value.$el.querySelector(`[scroll-node-key="${data.id}"]`);
                if (nodeEl) {
                    nodeEl.scrollIntoView({ behavior: 'smooth' });
                }
            }
        });
    }, 500);
};

// MARK el-tree  节点点击
const eltree_node_click = (data, node, el) => {
    if (data.subCatalogs.length) {
        ref_eltree.value.setCurrentKey(null);
        return;
    }
    if (eltree_sel_data.value && eltree_sel_data.value.id && data.id && eltree_sel_data.value.id == data.id) {
        return; // 重复点击失效，路由切换会进行事件发送，造成重复点击，过滤掉此操作
    }
    eltree_sel_data.value = data;
    state_store.docs_content_type_curr = data.displayType;
    props.tree_node_callback(data, treeList.value);
};

// MARK Find 多级数组嵌套查询对象
const find_tree_node = (array, field, value) => {
    for (let i = 0; i < array.length; i++) {
        const obj = array[i];
        if (obj[field] === value) {
            return obj;
        } else if (obj.subCatalogs) {
            const result = find_tree_node(obj.subCatalogs, field, value);
            if (result) {
                return result;
            }
        }
    }
    return null;
};

// MARK Message消息通知  目录树点击
const m_e_tree_auto_sel_node = (evented) => {
    eltree_auto_loc(evented.treeId);
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-docs-tree {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    overflow: hidden;
    box-sizing: border-box;
    padding-right: 10px;
    box-sizing: border-box;
    border-right: 1px solid var(--color-main-doc-segmentation-line-bg);
    user-select: none;

    :deep(.docs-tree-search-box) {
        position: relative;
        height: 40px;
        display: flex;
        margin-top: 20px;
        margin-left: 48px;
        margin-right: 0px;
        overflow: hidden;
        flex-shrink: 0;

        .fold-box {
            position: relative;
            margin-left: 8px;
            display: flex;
            flex-shrink: 0;
            width: 32px;
            height: 100%;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                position: relative;
                width: 32px;
                height: 32px;
            }

            &:hover {
                img {
                    background-color: rgba(0, 0, 0, 0.05);
                    border-radius: 2px;
                }
            }

            i {
                color: var(--color-main-brand);
                font-size: 24px;
            }
        }
        .search-input-box {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            border-radius: 2px;
            border: 1px solid var(--color-main-border-gray);

            .el-input .el-input__wrapper {
                width: calc(100% - 30px);
                box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
            }
        }
    }

    :deep(.docs-tree-box) {
        display: flex;
        position: relative;
        margin: 15px 0px 0px 48px;
        padding: 0px 20px 0px 0px;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;

        .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
            box-sizing: border-box;
            border-left: 3px solid var(--color-main-brand);
            background: var(--color-main-brand-hover-light);
            border-radius: 2px;

            .node-sel-content-box {
                color: var(--color-main-brand);
            }
        }

        .el-tree {
            position: relative;
            width: 100%;

            .el-tree-node__content {
                height: unset !important;
                margin-top: 4px;
                border-left: 3px solid var(--color-main-border-transparent);

                &:hover {
                    background: var(--color-main-brand-hover-light);
                    border-radius: 2px;
                }

                .el-tree-node__expand-icon {
                    font-size: 20px;
                    color: var(--color-main-text-disabled);
                }

                .el-tree-node__expand-icon.is-leaf {
                    color: transparent !important;
                }
            }

            .custom-tree-node-highlight {
                color: var(--color-main-brand);
                font-weight: bold;
            }

            .custom-tree-node-bole,
            .custom-tree-node-leaf {
                position: relative;
                display: flex;
                flex: 1;
                padding: 0px 6px;
                box-sizing: border-box;
                flex-shrink: 0;
                align-items: center;
                height: 36px;
                overflow: hidden;

                .custom-tree-node-title-bole {
                    flex: 1;
                    position: relative;
                    font-weight: 400;
                    color: var(--color-main-text-primary);
                    display: flex;
                    align-items: center;
                    font-size: 16px;
                    line-height: 24px;
                }

                .custom-tree-node-leaf-box {
                    position: relative;
                    flex: 1;
                    width: 100%;
                    display: flex;

                    .node-leaf-content-box {
                        position: relative;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;

                        .node-sel-content-box-text {
                            font-weight: 400;
                            width: 100%;
                            font-size: 16px;
                            color: var(--color-main-text-primary);
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }
                }
            }
        }
    }
}
</style>
